import styled from "styled-components";

export const TextWrapper = styled.div`
    margin: auto 0.5rem;
    height: 1.75rem;
    padding-top: 0.1rem;
`;
